import React from 'react';
import SortableList from 'jd-library/SortableList';
import { useSelector } from 'react-redux';
import SingleSortItem from './SingleSortItem';

const SortItemList = (props) => {
	const {
		items,
		moveOption
	} = props;

	let isMobile = useSelector(state => {
		return state.library.deviceData.isMobile
	})

	let inIFrame = (window.top != window.self) ? true : undefined;

	const renderItem = (item,i) => {
		return (
			<SortableList
				key={i}
				index={i}
				id={i} 
				moveItem={moveOption}
				type='ListItem'
				accept='ListItem'
				renderItem={(dropRef, drag) => (
					<div ref={dropRef} className=''>
						<SingleSortItem
							ref={drag}
							item={item}
							index={i}
						/>
					</div>
				)}
			/>
		)
	}

	return (
		<div className='add-wrapper'>
			<SortableList.Wrapper isMobile={inIFrame ? false : isMobile}>
				{items.map(renderItem)}
			</SortableList.Wrapper>
		</div>
	)
}

export default SortItemList;
